import { Injectable } from '@angular/core';
import {    CanActivate,
            CanActivateChild,
            ActivatedRouteSnapshot,
            RouterStateSnapshot,
            Router
        } from '@angular/router';
import { Observable } from 'rxjs';

import { User } from '../_models/user.model';
import { StorageService } from '../_services/storage.service';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class LoginGuard implements CanActivate {

    private user: User;

    constructor(private router: Router,
                private storageService: StorageService,
                private authService: AuthService
    ) {
        this.storageService.userInfo.subscribe(user => this.user = user);
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot):
            Promise<boolean> | Observable<boolean> | boolean {
        if (this.user) {

          this.router.navigate(['']);
          // console.log("comprobacion user activo")
            return false;
        }

        return true;
    }

}
